// @core/api/endpoints/audittrail/get_audit_record.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AuditRecordResponse,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Get audit record by ID
 * Retrieves a single audit record by its unique identifier, including hash chain data.
 */
export async function GetAuditRecord(
  record_id: string,
  options?: RequestOptions
): Promise<AuditRecordResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/audit/records/:record_id`;
  requestPath = requestPath.replace(':record_id', encodeURIComponent(record_id));
  const requestOptions = options;
  return client.get<AuditRecordResponse>(requestPath, { ...requestOptions });
}
